import { render, staticRenderFns } from "@/manager/convocation/views/convocationDetail/addParticipantModal/addParticipantModal.pug?vue&type=template&id=6a0cb3ea&scoped=true&lang=pug&external"
import script from "./addParticipantModal.view.vue?vue&type=script&lang=ts"
export * from "./addParticipantModal.view.vue?vue&type=script&lang=ts"
import style0 from "./addParticipantModal.view.vue?vue&type=style&index=0&id=6a0cb3ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0cb3ea",
  null
  
)

export default component.exports